import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=59d9aaa3"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"
import style0 from "./Credits.vue?vue&type=style&index=0&id=59d9aaa3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports